export type ResourceVisibility = 'private' | 'company' | 'shared';

export interface ResourceAccess {
  visibility: ResourceVisibility;
  shared_with_user_ids: string[];
}

export const DEFAULT_RESOURCE_ACCESS: ResourceAccess = {
  visibility: 'private',
  shared_with_user_ids: [],
};
